import React from 'react';
import { ITileProps } from './types';
import {
  Container,
  Header,
  HeaderText,
  Flex,
  Avatar,
  Cover,
  Body,
} from './Tile.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Tile: React.FC<ITileProps> = ({
  icon,
  heading,
  image,
  content,
  onClick,
}) => {
  return (
    <Container onClick={onClick}>
      <Header>
        <Flex>
          <Avatar>
            <FontAwesomeIcon icon={icon} />
          </Avatar>
          <HeaderText>{heading}</HeaderText>
        </Flex>
      </Header>
      <Cover>
        <img src={image} alt={heading} />
      </Cover>
      <Body>{content}</Body>
    </Container>
  );
};
